
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import CTAButtons from "../components/sticky-button";
import React, { useState } from "react";
import BrochureForm from "../components/EnquiryForm";
import PageHeader from "./PageHeader";
import "./ChairmanMessage.css";
import ContactAdmissionsStrip from "../components/ContactAdmissionsStrip";

const messageParagraphs = [
  "Never before in the history of independent India the need for quality education has been as critical as now when we are witnessing the dawn of globalization in real sense of the term.",
  "The quality consciousness is seeping through all walks of life, may it be education, training, services or manufacturing activities. Earlier we understand the importance of International quality standards, brighter will be our future.",
  "With the arrival of multinational enterprises in developing countries, the skilled manpower requirements in the organized industrial sector are being redefined. More stringent standards in technical education and training are being evolved. As a result a new breed of computer professionals, from managers to programmers trained as per the international norms is the immediate need of the industry.",
  "I am sure that Thakur Institute of Management Studies, Career Development and Research (TIMSCDR) with its marvelous infrastructure and qualified staff will contribute positively towards moulding a new generation of computer professionals worthy of serving the industry in the emerging scenario and participate in the process of nation building.",
  "I am sure your visit to our campus will be pleasant and fruitful.",
];

function Chairman() {
const [showForm, setShowForm] = useState(false);

  return (
    <div className="chairman-page">
      <Navbar setShowForm={setShowForm} />
      {showForm && <BrochureForm setShowForm={setShowForm} />}
      <CTAButtons />

      <PageHeader
        title="Chairman's Message"
        crumbs={[
          { label: "Home", href: "/" },
          { label: "Chairman's Message" },
        ]}
      />

      <main className="chairman-message-wrap">
        <section className="chairman-message-card" aria-labelledby="chairman-message-title">
          <aside className="chairman-profile">
            <img src="/images/chairman.webp" alt="Shri. V K Singh" />
            <div className="chairman-profile-caption">
              <h2 id="chairman-message-title">Shri. V K Singh</h2>
              <p>Chairman</p>
              <span aria-hidden="true" />
            </div>
          </aside>

          <article className="chairman-copy">
       <span className="chairman-quote-mark" aria-hidden="true">
  &ldquo;
</span>
            {messageParagraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}

       <div className="chairman-signature">
  <strong>Shri. V K Singh</strong>
  <span>Chairman, TIMSCDR</span>
</div>
          </article>
        </section>
      </main>
<ContactAdmissionsStrip onAppointmentClick={() => setShowForm(true)} />      <Footer />
    </div>
  );
}

export default Chairman;
